import { find } from "lodash";
export const isAdmin = (user) => !!user && user.role === "ADMIN";
export const isCustomerAdmin = (user, customer) => !!user &&
    (isAdmin(user) ||
        (user.role.toUpperCase() === "CUSTOMER_ADMIN" && customer.id === user.customerId) ||
        (!!customer && !!find(user.adminCustomers, (c) => c.id === customer.id)));
